export const memberListSorts = ['slotNumber', 'name', 'status', 'updatedAt'];
export function isMembersListResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const r = value;
    return (Number.isInteger(r.page) &&
        r.page > 0 &&
        Number.isInteger(r.pageSize) &&
        r.pageSize > 0 &&
        Number.isInteger(r.totalItems) &&
        r.totalItems >= 0 &&
        Number.isInteger(r.totalPages) &&
        r.totalPages >= 0 &&
        Array.isArray(r.items) &&
        r.items.every((x) => {
            if (typeof x !== 'object' || x === null)
                return false;
            const i = x;
            return (typeof i.id === 'string' &&
                (i.slotNumber === null || typeof i.slotNumber === 'string') &&
                (i.slotNumbers === undefined ||
                    (Array.isArray(i.slotNumbers) &&
                        i.slotNumbers.every((number) => typeof number === 'string'))) &&
                typeof i.nationalId === 'string' &&
                typeof i.givenNames === 'string' &&
                typeof i.familyNames === 'string' &&
                (i.email === null || typeof i.email === 'string') &&
                (i.primaryPhone === null || typeof i.primaryPhone === 'string') &&
                (i.status === 'active' || i.status === 'inactive') &&
                typeof i.updatedAt === 'string' &&
                !Number.isNaN(Date.parse(i.updatedAt)));
        }));
}
